const PLANS = {
  SET_FEATURES_DATA: 'SET_FEATURES_DATA',
  SET_TOTAL_EMPLOYEES: 'SET_TOTAL_EMPLOYEES',
  SET_ACTIVE_PLAN: 'SET_ACTIVE_PLAN',

};
export default PLANS;
